import Head from 'expo-router/head';

import AddPaymentMethodsPage from '@fhs-legacy/frontend/src/components/add-payment-method-modal/add-payment-method-modal';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function AddCardRoute() {
  return (
    <>
      <Head>
        <title>Add Payment Method - Firehouse Subs</title>
      </Head>
      <AddPaymentMethodsPage />
    </>
  );
}
